import { createFileRoute } from "@tanstack/react-router";
import { MilestonesPage } from "@/components/planning/milestones/MilestonesPage";

export const Route = createFileRoute("/_app/p/$productKey/milestones/")({ component: View });

function View() {
  const { productKey } = Route.useParams();
  return <MilestonesPage productKey={productKey} />;
}
